import type { APISharedProfileHeader } from '@see-stella/types'

/**
 * Which timeline sub-components are visible for a shared profile. Photos and
 * Metrics are INDEPENDENT sections (photos-only, metrics-only, or both) rendered
 * as component visibility on the one shared scrubber layout — no separate views.
 *
 * - `photos`: the photo viewer (image / abstract face) and its prefetch window.
 * - `metrics`: the metric chart, switcher, definition, and the on-photo score.
 * - `regionDots`: per-region dots + drill-down. They overlay the photo AND read a
 *   metric score, so they need BOTH sections on.
 *
 * The same function feeds the recipient view and the in-app owner preview, so the
 * two are identical by construction (spec §; plan Slice 4 task 4.3).
 */
export interface SectionVisibility {
  photos: boolean
  metrics: boolean
  regionDots: boolean
}

export function sectionVisibility(
  header: Pick<APISharedProfileHeader, 'includesPhotos' | 'includesMetrics'>
): SectionVisibility {
  return {
    photos: header.includesPhotos,
    metrics: header.includesMetrics,
    regionDots: header.includesPhotos && header.includesMetrics,
  }
}
